/** 拥有者 */
export const ROLE_ID_OWNER = 1;
/** 管理员 */
export const ROLE_ID_MANAGER = 2;
/** 成员 */
export const ROLE_ID_MEMBER = 3;
